import { useEffect, useRef } from "react";

/**
 * Calls onScrollDown whenever the user scrolls further down the page, for as long as isActive is true.
 * Scrolling up never triggers it. The listener resets its reference point every time isActive
 * switches to true, so it only reacts to scroll movement that happens while active.
 */
export function useOnScrollDown(isActive: boolean, onScrollDown: () => void): void {
  const onScrollDownRef = useRef(onScrollDown);
  onScrollDownRef.current = onScrollDown;

  useEffect(() => {
    if (!isActive) {
      return;
    }

    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        onScrollDownRef.current();
      }
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isActive]);
}
